import 'modaal';

function initModal(trigger) {
    var modalType = $(trigger).data('modal-type');
    $(trigger).modaal({
        type: modalType
    });
}

export default {
    initModal : initModal
}


// WEBPACK FOOTER //
// ./src/js/modal.js